import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { ThemePalette } from 'shared-components/core/mixins';

import { Snackbar, SnackbarAction, SnackbarIconConfiguration } from '../../models';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'evi-mobile-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SnackbarComponent {
  public readonly visibility$: Observable<boolean> = this._snackbarService.visibility$.pipe(
    tap((isVisible: boolean) => isVisible && (this.snackbar = this._snackbarService.snackbar)),
  );

  public snackbar: Snackbar | undefined;

  public get color(): ThemePalette | undefined {
    return this.snackbar?.color;
  }

  public get icon(): SnackbarIconConfiguration | undefined {
    return this.snackbar?.icon;
  }

  public get leftAction(): SnackbarAction | undefined {
    return this.snackbar?.actions.left;
  }

  public get rightAction(): SnackbarAction | undefined {
    return this.snackbar?.actions.right;
  }

  constructor(
    private readonly _snackbarService: SnackbarService,
  ) {
    this.snackbar = this._snackbarService.snackbar;
  }
}
